// Client-side mirror of lib/reservationStatus.js — the single source of truth
// for which reservation statuses count as confirmed bookings. If the server
// list changes, change BOTH files (the server module is CommonJS and can't be
// imported here directly).
//
// Hostaway carries ~1k inquiries with prices+dates that look exactly like
// bookings; any client query that reads `reservations` from Supabase directly
// must use this allowlist or it will show inquiries as bookings.

export const CONFIRMED_STATUSES = ['new', 'modified', 'confirmed', 'reserved'] as const;

// Statuses a person browsing the reservation table reasonably expects to see:
// real bookings plus cancellations. Never inquiries/pending/expired noise.
export const BROWSABLE_STATUSES = [...CONFIRMED_STATUSES, 'cancelled'] as const;

const CONFIRMED_SET = new Set<string>(CONFIRMED_STATUSES);
export const isConfirmed = (r: { status?: string | null }): boolean =>
  !!r?.status && CONFIRMED_SET.has(r.status);
